import vuexStore from '../../store/vuexStore'

export default {
  data () {
    return {
      window: {
        width: 0,
        height: 0
      },
      showFallenJackpots: false,
      fallenJackpots: {
        showSlider: '',
        ticketNo: 0,
        ticketLocation: '',
        jackpotAmount: ''
      },
      hasAudioEnabled: vuexStore.state.hasAudioEnabled,
      videoSeek: 0,
      videoList: [],
      videoListTemp: [],
      secondsToStart: 0,
      roundLength: 180,
      noBetsPeriod: 10,
      isBettingEnabled: false,
      selectedTab: 0,
      roundResult: null,
      roundLastTenResult: null,
      previousMatch: null,
      previousRoundNo: 0,
      roundNo: 0,
      match: null,
      showLeftMenu: false,
      showModal: false,
      showConnectionErrorModal: false,
      showMatchResult: false,
      showBettingHistory: false,
      isRoundResultCalled: false,
      fullScreenActive: false,
      openConfirmModal: false,
      numberOfTicketsInList: 0,
      getConfigCounter: 0,
      config: null,
      elementVGames: null,
      totalVideoLength: 0
    }
  }
}
